const getEmail = () => {
    const dest = ['m', 'a', 'g', 'g', 'i', 'e'],
    provider = [
      's', 't', 'o', 'n', 'y', 'b', 'r', 'o', 'o', 'k', 's', 't', 'r', 'i', 'n', 'g', 's'
    ];

    return `${[dest.join(''), provider.join('')].join('@')}.com`
}

export default getEmail